// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__32lVW","title":"Header_title__1GFPI","left":"Header_left__V-7So","clinicName":"Header_clinicName__1-q_J"};